module.exports = __webpack_public_path__ + "static/media/25.a777ac5c.jpg";